import React, {useState, useEffect} from 'react';
import {FilterMatchMode, FilterOperator} from 'primereact/api';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import './DataTableDemo.css';

const GridFilterDemo = () => {
    const [customers1, setCustomers1] = useState([{name: 'anik biswas', age: 28}, {
        name: 'Nur E alam',
        age: 22
    }, {name: 'Mohammad Asaf', age: 33}]);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [loading1, setLoading1] = useState(false);


    useEffect(() => {
        initFilters1();
    }, []);


    const clearFilter1 = () => {
        initFilters1();
    }

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }


    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'name': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'age': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
            'representative': {value: null, matchMode: FilterMatchMode.IN},
            'date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]},
            'balance': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
            'status': {operator: FilterOperator.OR, constraints: [{value: null, matchMode: FilterMatchMode.EQUALS}]},
            'activity': {value: null, matchMode: FilterMatchMode.BETWEEN},
            'verified': {value: null, matchMode: FilterMatchMode.EQUALS}
        });
        setGlobalFilterValue1('');
    }

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter1}/>
                <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Keyword Search"/>
                </span>
            </div>
        )
    }


    const header1 = renderHeader1();

    return (
        <div className="datatable-filter-demo">
            <div className="card">
                <h5>Filter Menu</h5>
                <p>Filters are displayed in an overlay.</p>
                <DataTable value={customers1} paginator className="p-datatable-customers" showGridlines rows={10}
                           dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1}
                           responsiveLayout="scroll"
                           globalFilterFields={['name', 'age', 'representative.name', 'balance', 'status']}
                           header={header1} emptyMessage="No customers found.">
                    <Column field="name" header="Name" filter filterPlaceholder="Search by name"
                            style={{minWidth: '12rem'}}/>
                    <Column field="age" header="Age" filter filterPlaceholder="Search by Age"
                            style={{minWidth: '12rem'}}/>

                </DataTable>
            </div>

        </div>
    );
}

export default GridFilterDemo